import { FC, useEffect, useState } from "react";
import "./OneDayPassDetailScreen.css";
import backIcon from "../../../assets/images/back-icon.svg";
import orangeStarIcon from "../../../assets/images/membership-orange-star.svg";
import { useNavigate } from "react-router-dom";

const OneDayPassDetailScreen: FC = () => {
  const navigate = useNavigate();
  const [selectedPassData, setSelectedPassData] = useState<any>(null);

  useEffect(() => {
    const storedData = localStorage.getItem("selectedFullDayPassData");
    if (storedData) {
      setSelectedPassData(JSON.parse(storedData));
    }
  }, []);

  const handleBackButtonClick = () => {
    navigate(-1);
  };

  return (
    <div className="wms-mobile-container">
      <div className="one-day-pass-detail-screen-container">
        <div className="one-day-pass-detail-header-container">
          <img
            src={backIcon}
            alt="dropdown-logo"
            className="image"
            onClick={handleBackButtonClick}
          />
          <div className="title">{selectedPassData?.title}</div>
        </div>
        <div className="one-day-pass-detail-content-container">
          <span>Full day access</span>
          <div className="divider"></div>
          <div className="one-day-pass-detail-content-text-container">
            <img src={orangeStarIcon} alt="star-icon" />
            <div className="detail-text">{`Full Day Pass At Price ₹${selectedPassData?.pass_price}`}</div>
          </div>
        </div>
        <div className="one-day-pass-detail-content-container">
          <span>Validity</span>
          <div className="divider"></div>
          <div className="one-day-pass-detail-content-text-container">
            <img src={orangeStarIcon} alt="star-icon" />
            <div className="detail-text">{`${selectedPassData?.pass_validity} ${
              selectedPassData?.pass_validity > 1 ? "Months" : "Month"
            }`}</div>
          </div>
        </div>
        <div className="one-day-pass-detail-content-container">
          <span>Details</span>
          <div className="divider"></div>
          <div className="one-day-pass-detail-content-text-container">
            <div className="detail-text">{selectedPassData?.discription}</div>
          </div>
        </div>
        
      </div>
      <div className="one-day-pass-detail-purchase-btn">Purchase</div>
    </div>
  );
};

export default OneDayPassDetailScreen;
